import { useQuery } from '@tanstack/react-query';
import { getVirtualMedicines } from '../requests';

export const useVirtualMedicines = (masterMedicineId?: string) => {
  const isEnabled = Boolean(masterMedicineId);

  const { data, isLoading } = useQuery({
    queryFn: () => (masterMedicineId ? getVirtualMedicines(masterMedicineId) : null),
    queryKey: ['virtual-medicines', masterMedicineId],
    enabled: isEnabled
  });

  return {
    virtualMedicines: data?.data.data || [],
    isLoading: isEnabled && isLoading,
    total: data?.data.pagination?.total
  };
};
